import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../components/checkbox/CheckBox";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import Autocomplete from "../../../../../../components/autocomplete/Autocomplete";
import Select from "../../../../../../components/select/Select";

const zoneItalia = OggettiUtili.ZoneItalia;

class AltriFattori extends Component {
    state = {
        altriFattori: {
            viaggio: "",
            luogoViaggio: "",
            zonaItalia: "",
            dataInizio: "",
            dataFine: "",
            fattoria: "",
            giardinaggio: "",
            orto: "",
            letame: "",
            caccia: "",
            animaliDomestici: "",
            animaleDomesticoSpecifico: "",
            animaliAllevamento: "",
            animaleAllevamentoSpecifico: "",
            contatti: "",
            rapporto: "",
            trasfusione: "",
            corretto: []

        },
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse((sessionStorage.getItem("nazioniPerCodice"))),
    }


    constructor(props) {
        super(props);
        this.mapObjectToList = this.mapObjectToList.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.pulisciValori = this.pulisciValori.bind(this);
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {

        let newState = this.state.altriFattori;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.altriFattori) {
            let altriFattoriCopia = this.props.segnalazioneCopia.schedaSpeciale.altriFattori;
            newState.viaggio = altriFattoriCopia.viaggio ? altriFattoriCopia.viaggio : "";
            newState.luogoViaggio = altriFattoriCopia.luogoViaggio && this.state.nazioniPerCodice[altriFattoriCopia.luogoViaggio] ? this.state.nazioniPerCodice[altriFattoriCopia.luogoViaggio] : "";
            newState.zonaItalia = altriFattoriCopia.zonaItalia ? altriFattoriCopia.zonaItalia : "";
            newState.dataInizio = altriFattoriCopia.dataInizio ? altriFattoriCopia.dataInizio : "";
            newState.dataFine = altriFattoriCopia.dataFine ? altriFattoriCopia.dataFine : "";
            newState.fattoria = altriFattoriCopia.fattoria ? altriFattoriCopia.fattoria : "";
            newState.giardinaggio = altriFattoriCopia.giardinaggio ? altriFattoriCopia.giardinaggio : "";
            newState.orto = altriFattoriCopia.orto ? altriFattoriCopia.orto : "";
            newState.letame = altriFattoriCopia.letame ? altriFattoriCopia.letame : "";
            newState.caccia = altriFattoriCopia.caccia ? altriFattoriCopia.caccia : "";
            newState.animaliDomestici = altriFattoriCopia.animaliDomestici ? altriFattoriCopia.animaliDomestici : "";
            newState.animaleDomesticoSpecifico = altriFattoriCopia.animaleDomesticoSpecifico ? altriFattoriCopia.animaleDomesticoSpecifico : "";
            newState.animaliAllevamento = altriFattoriCopia.animaliAllevamento ? altriFattoriCopia.animaliAllevamento : "";
            newState.animaleAllevamentoSpecifico = altriFattoriCopia.animaleAllevamentoSpecifico ? altriFattoriCopia.animaleAllevamentoSpecifico : "";
            newState.contatti = altriFattoriCopia.contatti ? altriFattoriCopia.contatti : "";
            newState.rapporto = altriFattoriCopia.rapporto ? altriFattoriCopia.rapporto : "";
            newState.trasfusione = altriFattoriCopia.trasfusione ? altriFattoriCopia.trasfusione : "";

            this.setState({altriFattori: newState})
        }
        this.controlloDati();
        let objectForBackend = Object.assign({}, this.createObjectForBackEnd())
        this.props.setStatePadre(newState, "altriFattori", objectForBackend, this.validate())
    }

    createObjectForBackEnd() {
        let objectForBackEnd = {...this.state.altriFattori};
        objectForBackEnd.luogoViaggio = objectForBackEnd.luogoViaggio && objectForBackEnd.luogoViaggio.codice ? objectForBackEnd.luogoViaggio.codice : "";
        let objFinal = Utils.removeFieldFromObject(objectForBackEnd, "corretto")
        return Utils.removeEmptyValueFromObject(objFinal);
    }


    riceviValoreInput(field, event) {
        let newState = this.state.altriFattori;
        if (field && field.target && field.target.id) {
            newState[field.target.id] = field.target.value;
        } else {
            newState[field] = event.target.value;
        }
        let newStatePulito = this.pulisciValori(newState);
        this.setState({altriFattori: newStatePulito});
        this.controlloDati();
        let objectForBackend = Object.assign({}, this.createObjectForBackEnd())
        this.props.setStatePadre(newStatePulito, "altriFattori", objectForBackend, this.validate())
    }

    validate() {

        if (this.state.altriFattori.dataInizio) {
            let validatedataInizio = Utils.checkDateInterval(this.state.altriFattori.dataInizio, "31/12/1899");
            let validatedataInizioOdierna = Utils.checkDateInterval(this.state.altriFattori.dataInizio, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataInizio) {
                return "Messages.ERR_01_02_0I_0O"
            } else if (!validatedataInizioOdierna) {
                return "Messages.ERR_01_02_0I_0P"
            }
        }

        if (this.state.altriFattori.dataFine) {
            let validatedataFine = Utils.checkDateInterval(this.state.altriFattori.dataFine, "31/12/1899");
            let validatedataFineOdierna = Utils.checkDateInterval(this.state.altriFattori.dataFine, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataFine) {
                return "Messages.ERR_01_02_0I_0Q"
            } else if (!validatedataFineOdierna) {
                return "Messages.ERR_01_02_0I_0R"
            }
        }
        if (this.state.altriFattori.dataInizio && this.state.altriFattori.dataFine) {
            let confrontodataInizio = Utils.checkDateInterval(this.state.altriFattori.dataInizio, this.state.altriFattori.dataFine);
            let confrontodataFine = Utils.checkDateInterval(this.state.altriFattori.dataFine, this.state.altriFattori.dataInizio);


            if (!confrontodataInizio) {
                return "Messages.ERR_01_02_0I_0S"
            }
        }
        if (this.state.altriFattori.dataInizio && this.state.altriFattori.dataFine && this.props.dataSintomi) {
            let confrontodataInizio = Utils.checkDateInterval(this.state.altriFattori.dataInizio, this.state.altriFattori.dataFine);
            let confrontodataFine = Utils.checkDateInterval(this.state.altriFattori.dataFine, this.state.altriFattori.dataInizio);
            let confrontoSintomiDal = Utils.checkDateInterval(this.props.dataSintomi, this.state.altriFattori.dataInizio);

            if (!confrontodataInizio) {
                return "Messages.ERR_01_02_0I_0S"
            }
            if (confrontoSintomiDal) {
                return "Messages.ERR_01_02_0I_AV"
            }
        }

        return ""
    }


    pulisciValori(state) {
        let newState = state;
        if (newState.viaggio !== "01") {
            newState.luogoViaggio = "";
            newState.dataInizio = "";
            newState.dataFine = "";
        }
        if (newState.animaliDomestici !== "01") {
            newState.animaleDomesticoSpecifico = "";
        }
        if (newState.animaliAllevamento !== "01") {
            newState.animaleAllevamentoSpecifico = "";
        }
        if (newState.contatti !== "01") {
            newState.rapporto = "";
        }
        if (newState.luogoViaggio && newState.luogoViaggio.codice !== "100") {
            newState.zonaItalia = "";
        }
        return newState
    }


    controlloDati() {
        let altriFattori = this.state.altriFattori;
        altriFattori.corretto = [];

        if (altriFattori.dataInizio && (Utils.isDateInValid(Utils.transformDateForBackend(altriFattori.dataInizio), "-"))) altriFattori.corretto[0] = "Campo \"Dal:\" errato";
        if (altriFattori.dataFine && (Utils.isDateInValid(Utils.transformDateForBackend(altriFattori.dataFine), "-"))) altriFattori.corretto[1] = "Campo \"Al:\" errato";
        if (!altriFattori.zonaItalia && altriFattori.luogoViaggio?.codice === "100")
            altriFattori.corretto[2] = "Campo \"Luogo viaggio\" valorizzato con Italia ma il campo \"Zona dell'Italia visitata\" mancante"
        this.setState({altriFattori: altriFattori});
    }

    mapObjectToList(object) {
        let lista = []
        Object.keys(object).map((key) => {
            if (key !== 0 || key !== 99 || key !== 88)
                return lista.push(object[key]);
        })

        return (Utils.sortByKey(lista, "descrizione"));
    }

    render() {
        const {t} = this.props
        const zone = this.state.altriFattori?.luogoViaggio?.codice && this.state.altriFattori.luogoViaggio.codice === "100" ?
            (<div className={"row"}>
                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                        {t("SchedaSpecialeEpatiteE.AltriFattori.zoneItalia")}
                        <span className={styles.mandatoryColor}>*</span>
                    </p>
                    <Select id={"zonaItalia"}
                            value={this.state.altriFattori.zonaItalia}
                            onChange={this.riceviValoreInput}
                            functionMap={zoneItalia.map((oggetto) => {
                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                            })}
                    >
                    </Select>
                </div>
            </div>)
            : (<></>)

        return (
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Altri fattori di rischio (nei 2 mesi precedenti la malattia)</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.storiaViaggio")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"viaggioSi"}
                                             name={"viaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.viaggio === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"viaggioNo"}
                                             name={"viaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.viaggio === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"viaggioNonSo"}
                                             name={"viaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.viaggio === "03"}
                                />
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello3' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.dove")}
                                </p>
                                <Autocomplete id={"luogoViaggio"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"luogoViaggio"}
                                              placeholder={"Nazione"}
                                              suggestions={this.state.nazioni}
                                              disabled={this.state.altriFattori.viaggio !== "01"}
                                              value={this.state.altriFattori.luogoViaggio}
                                >
                                </Autocomplete>
                            </div>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.dal")}
                                </p>
                                <Calendar
                                    id={"dataInizio"}
                                    field={"dataInizio"}
                                    value={this.state.altriFattori.dataInizio}
                                    disabled={this.state.altriFattori.viaggio !== "01"}
                                    onChange={this.riceviValoreInput}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        "Data")}
                                    error={(this.state.altriFattori.dataInizio === "" ||
                                        this.state.altriFattori.dataInizio == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.altriFattori.dataInizio), "-")}
                                >
                                </Calendar>
                            </div>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.al")}
                                </p>
                                <Calendar
                                    id={"dataFine"}
                                    field={"dataFine"}
                                    value={this.state.altriFattori.dataFine}
                                    disabled={this.state.altriFattori.viaggio !== "01"}
                                    onChange={this.riceviValoreInput}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        "Data")}
                                    error={(this.state.altriFattori.dataFine === "" ||
                                        this.state.altriFattori.dataFine == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.altriFattori.dataFine), "-")}
                                >
                                </Calendar>
                            </div>

                        </div>

                        {zone}

                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.fattoria")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fattoriaSi"}
                                             name={"fattoria"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.fattoria === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fattoriaNo"}
                                             name={"fattoria"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.fattoria === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fattoriaNonSo"}
                                             name={"fattoria"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.fattoria === "03"}
                                />
                            </div>
                        </div>


                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.giardinaggio")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"giardinaggioSi"}
                                             name={"giardinaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.giardinaggio === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"giardinaggioNo"}
                                             name={"giardinaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.giardinaggio === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"giardinaggioNonSo"}
                                             name={"giardinaggio"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.giardinaggio === "03"}
                                />
                            </div>
                        </div>


                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.orto")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"ortoSi"}
                                             name={"orto"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.orto === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"ortoNo"}
                                             name={"orto"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.orto === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"ortoNonSo"}
                                             name={"orto"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.orto === "03"}
                                />
                            </div>
                        </div>


                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.letame")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"letameSi"}
                                             name={"letame"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.letame === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"letameNo"}
                                             name={"letame"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.letame === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"letameNonSo"}
                                             name={"letame"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.letame === "03"}
                                />
                            </div>
                        </div>


                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.caccia")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"cacciaSi"}
                                             name={"caccia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.caccia === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"cacciaNo"}
                                             name={"caccia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.caccia === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"cacciaNonSo"}
                                             name={"caccia"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.caccia === "03"}
                                />
                            </div>
                        </div>

                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-7"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.animaliDomestici")}
                                </p>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"animaliDomesticiSi"}
                                                     name={"animaliDomestici"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliDomestici === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"animaliDomesticiNo"}
                                                     name={"animaliDomestici"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliDomestici === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"animaliDomesticiNonSo"}
                                                     name={"animaliDomestici"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliDomestici === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.specificare")}
                                </p>
                                <Input
                                    type={"textarea"}
                                    id={"animaleDomesticoSpecifico"}
                                    onChange={this.riceviValoreInput}
                                    field={"animaleDomesticoSpecifico"}
                                    disabled={this.state.altriFattori.animaliDomestici !== "01"}
                                    value={this.state.altriFattori.animaleDomesticoSpecifico}
                                    placeholder={"Animale domestico"}
                                />
                            </div>
                        </div>

                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-7"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.animaliAllevamento")}
                                </p>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"animaliAllevamentoSi"}
                                                     name={"animaliAllevamento"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliAllevamento === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"animaliAllevamentoNo"}
                                                     name={"animaliAllevamento"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliAllevamento === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"animaliAllevamentoNonSo"}
                                                     name={"animaliAllevamento"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.animaliAllevamento === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.specificare")}
                                </p>
                                <Input
                                    type={"textarea"}
                                    id={"animaleAllevamentoSpecifico"}
                                    onChange={this.riceviValoreInput}
                                    field={"animaleAllevamentoSpecifico"}
                                    disabled={this.state.altriFattori.animaliAllevamento !== "01"}
                                    value={this.state.altriFattori.animaleAllevamentoSpecifico}
                                    placeholder={"Animale allevamento"}
                                />
                            </div>
                        </div>

                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-7"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.contatti")}
                                </p>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"contattiSi"}
                                                     name={"contatti"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.contatti === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"contattiNo"}
                                                     name={"contatti"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.contatti === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"contattiNonSo"}
                                                     name={"contatti"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.altriFattori.contatti === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.rapporto")}
                                </p>
                                <Select
                                    id={"rapporto"}
                                    onChange={this.riceviValoreInput}
                                    field={"rapporto"}
                                    disabled={this.state.altriFattori.contatti !== "01"}
                                    value={this.state.altriFattori.rapporto}
                                    functionMap={this.mapObjectToList(OggettiUtili.Contatti).map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}>
                                </Select>
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.AltriFattori.trasfusione")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"trasfusioneSi"}
                                             name={"trasfusione"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.trasfusione === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"trasfusioneNo"}
                                             name={"trasfusione"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.trasfusione === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"trasfusioneNonSo"}
                                             name={"trasfusione"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.altriFattori.trasfusione === "03"}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default withTranslation('common')(AltriFattori)
